import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { trigger, transition, style, animate } from '@angular/animations';

import { SharedUtilsService } from 'src/app/core/services/shared-utils.service';


@Component({
  selector: 'app-listepopup',
  templateUrl: './listepopup.component.html',
  styleUrls: ['./listepopup.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(8px)' }),
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class ListepopupComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any
  , public dialogRef: MatDialogRef<ListepopupComponent>
  , public sharedUtilsService: SharedUtilsService
  ) { }

  estEnChargement: boolean = false;

  sourceDonnees: any[] = [];
  donneesFiltrees: any[] = [];
  termeRecherche: string = '';
  hoveredLivreur: number | null = null;

  ngOnInit(): void {
    this.estEnChargement = true;

    const idCommande = this.data?.dataId;
    if (this.data?.dataName === 'LivreursDisponibles' && (idCommande === null || idCommande === undefined || idCommande === '')) {
      this.estEnChargement = false;
      this.sourceDonnees = [];
      this.donneesFiltrees = [];
      return;
    }

    this.sharedUtilsService.obtenirListeDonnees(this.data).subscribe(
      (reponse) => {
        this.sourceDonnees = reponse;
        this.donneesFiltrees = reponse;
        this.estEnChargement = false;
      },
      (erreur) => {
        console.error('Erreur lors du chargement des données:', erreur);
        this.estEnChargement = false;
        this.sourceDonnees = [];
        this.donneesFiltrees = [];
      }
    );
  }

  surRecherche(): void {
    if (!this.termeRecherche || this.termeRecherche.trim() === '') {
      this.donneesFiltrees = [...this.sourceDonnees];
      return;
    }

    const terme = this.termeRecherche.toLowerCase().trim();

    // Recherche spécifique pour les livreurs
    if (this.data.dataName === 'LivreursDisponibles') {
      this.donneesFiltrees = this.sourceDonnees.filter((livreur: any) => {
        return (
          (livreur.nom && livreur.nom.toLowerCase().includes(terme)) ||
          (livreur.prenom && livreur.prenom.toLowerCase().includes(terme)) ||
          (livreur.contact && livreur.contact.toLowerCase().includes(terme)) ||
          (livreur.adresse && livreur.adresse.toLowerCase().includes(terme)) ||
          (livreur.email && livreur.email.toLowerCase().includes(terme))
        );
      });
    } else {
      // Recherche générique pour les autres types
      this.donneesFiltrees = this.sourceDonnees.filter((element: any) => {
        return this.data.displayedColumns.some((colonne: any) => {
          const valeur = this.obtenirDonneesColonne(element, colonne.field);
          return valeur && valeur.toString().toLowerCase().includes(terme);
        });
      });
    }
  }

  obtenirDonneesColonne(donnees: any, nomsColonnes: string): String {
    return this.sharedUtilsService.obtenirValeurDepuisObjet(donnees, nomsColonnes);
  }

  selectionner(donnees: any) {
    this.dialogRef.close(donnees);
  }

}
